import {Component, Input} from '@angular/core';

/** Five stars, filled up to the rating rounded to a whole star. */
@Component({
    selector: 'app-star-rating',
    standalone: true,
    template: `
        <span class="inline-flex items-center leading-none" role="img" [attr.aria-label]="'Оценка ' + rating + ' од 5'">
            @for (star of stars; track star) {
                <span aria-hidden="true" [class]="sizeClass" [class.text-yellow-500]="star <= filled" [class.text-gray-300]="star > filled">★</span>
            }
        </span>
    `
})
export class StarRatingComponent {

    @Input()
    rating: number = 0;

    @Input()
    sizeClass: string = 'text-base';

    readonly stars = [1, 2, 3, 4, 5];

    get filled(): number {
        return Math.round(this.rating);
    }
}
